import React, { useEffect, useRef, version } from 'react';
import { useNavigate, } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import RoutesDefinition from './Shell/RoutesV2';
import Paper from '@mui/material/Paper';
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { styled } from "@mui/material/styles";
import IosShareIcon from '@mui/icons-material/IosShare';
import { Box, Button, Divider, IconButton, Snackbar, Typography, useMediaQuery } from '@mui/material';
import { useAppContext } from './Shell/AppContext';
import CloseIcon from '@mui/icons-material/Close';
import constant from './Shell/Constant';
import AppSignalRManager from './Shell/AppSignalManager';
import GlobalStyles from './Shell/GlobalStyles';
import Helpers from './Shell/Helper';
import { setNavigator } from './Shell/Navigation';
import BackdropLoader from './Components/Loaders/BackdropLoader';
import { useSelector } from 'react-redux';
import GlobalSnackbar from './Components/Alerts/GlobalSnackbar';
import heartBlack from "./Assets/heartBlack.png"
import rocketIcon from "./Assets/images/rocket.png"
import happyfaceIcon from "./Assets/images/happyface.png"
import { dark, light } from './Shell/ThemeV2';
import GlobalToast from './ComponentsV2/common/GlobalToast';
import { initOfflineSync } from './Services/Offline/syncEngine';

const DialogBox = styled(Dialog)(({ theme }) => ({
    "& .titleDialog": {
        display: "flex",
        padding: "10px",
        fontWeight: "bold",
        "& p": {
            fontSize: "18px"
        }
    },
    "& .description": {
        height: "120px",
        "& h6": {
            fontSize: "16px",
            lineHeight: "inherit"
        },
        "& .buttons": {
            display: "flex",
            justifyContent: "space-between",
            "& Button": {
                width: "48%",
                marginTop: "20px",
                alignSelf: "center"
            }
        },
    },
    '& .rocket': {
        transform: "rotate(45deg)"
    },
    "& .UpdatedDescription": {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "auto",
        gap: "6px",
        "& h6": {
            textAlign: "center",
            fontSize: "16px",
        },
    },
    "& .heartimg": {
        margin: "0 auto",
        width: "80px"
    },

    "& .closeBtn": {
        fontSize: 16,
        color: theme.palette.primary.main
    },
}));
const Root = styled(Box)(({ theme }) => ({
    boxShadow: "none",
    ".topLeftButton": {
        position: 'absolute',
        right: "0px",
        top: "8px",
        color: "black",
        zIndex: "99",
        "& svg": {
            fontSize: "25px",
        },
        '&.refresh': {
            right: 30,
        }
    },
    "& .sideBar": {
        position: " absolute",
        zIndex: "9999999999999999",
    }
}));
function AppV2() {
    const refreshTokenLoader = useSelector((state) => state?.token?.isLoadingRefreshToken);
    const [showPopup, setShowPopup] = React.useState(false);
    const [pathMenu, setPathMenu] = React.useState()
    const [isOpenDrawer, setIsOpenDrawer] = React.useState()
    const [dialogText, setDialogText] = React.useState("New version 2023.05.09.001 is available.")

    const [openDialog, setOpenDialog] = React.useState(false);
    const [openUpdatedDialog, setOpenUpdatedDialog] = React.useState(false);
    const [versionNo, setVersionNo] = React.useState("2023.01.01.000");
    const [isDarkMode, setIsDarkMode] = React.useState(localStorage?.getItem('darkMode') || false);
    const [clickCount, setClickCount] = React.useState(0);
    const [versionText, setVersionText] = React.useState("");
    const currentDate = `${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`;
    const firstStart = useRef(true);
    const updateIntervalRef = useRef(null);
    const updateTimeoutRef = useRef(null);
    const isUpdateInProgressRef = useRef(false);
    const { data, setData } = useAppContext({});
    let isTab = useMediaQuery('(min-width:600px)');
    React.useEffect(() => {
        if (firstStart.current) {
            // window.title = "Drivers - My Senior Center";
            firstStart.current = false;
            initOfflineSync();
            // Check for updates at first after 3 second
            updateTimeoutRef.current = setTimeout(() => {
                updateApp();
            }, 3000);
            // Check for updates later every 10 seconds
            updateIntervalRef.current = setInterval(() => {
                updateApp();
            }, 30000);
        }
        //check PWA install in ios
        const isIos = () => {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod/.test(userAgent);
        };
        const isPwaInstalled = () => {
            return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
        };
        const isSafari = () => {
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        };
        const shouldShowPopup = (isIos() || isSafari()) && !isPwaInstalled();
        setShowPopup(shouldShowPopup)

        //dark and Light mode
        const darkMode = JSON.parse(localStorage?.getItem('darkMode') || true);
        setIsDarkMode(darkMode);
        // updated popup
        let ShowUpdateDialog = localStorage.getItem("ShowUpdateDialog");
        if (ShowUpdateDialog === "true") {
            setOpenUpdatedDialog(true);
            localStorage.removeItem("ShowUpdateDialog");
        }
        let appVersion = localStorage.getItem("APP_VERSION");
        setVersionText(`App is Updated to ${appVersion || "Latest Version"}`);

        return () => {
            if (updateTimeoutRef.current) {
                clearTimeout(updateTimeoutRef.current);
            }
            if (updateIntervalRef.current) {
                clearInterval(updateIntervalRef.current);
            }
        };

    }, [])
    useEffect(() => {
        if (!('serviceWorker' in navigator)) {
            console.warn('[SW] Service Workers are not supported in this browser');
            return;
        }

        // Log current state on load
        navigator.serviceWorker.ready
            .then(reg => {
                console.log('[SW] Service Worker is ready → active scope:', reg.scope);
                console.log('[SW] → active:', reg.active?.state || 'no active yet');
                console.log('[SW] → installing:', reg.installing?.state || 'none');
                console.log('[SW] → waiting:', reg.waiting?.state || 'none');
            })
            .catch(err => {
                console.error('[SW] ready promise failed:', err);
            });

        // Listen for future registrations / changes
        navigator.serviceWorker.addEventListener('controllerchange', e => {
            console.log('[SW] Controller changed! New controlling SW:', navigator.serviceWorker.controller?.scriptURL);
        });

        navigator.serviceWorker.addEventListener('message', event => {
            console.log('[SW] Message received from service worker:', event.data);
        });

        // Optional: periodic check (useful during dev)
        const logCurrentSW = () => {
            navigator.serviceWorker.getRegistration().then(reg => {
                if (reg) {
                    console.log('[SW Status]', {
                        scope: reg.scope,
                        active: reg.active?.state,
                        installing: reg.installing?.state,
                        waiting: reg.waiting?.state,
                        navigationPreload: reg.navigationPreload?.enabled ?? 'not supported'
                    });
                } else {
                    console.log('[SW] No registration found right now');
                }
            });
        };

        logCurrentSW(); // immediate
        // const interval = setInterval(logCurrentSW, 10000); // every 10s – remove in prod if not needed

        // return () => clearInterval(interval);
    }, []);



    //PWA
    const handleCloseIOSPWADialog = () => {
        setShowPopup(false);
    };
    // ======== Dialog  =======
    const handleClose = () => {
        localStorage.setItem("APP_ALERT", currentDate)
        setOpenDialog(false);
    };
    const handleCloseUpdatedDialog = () => {
        setOpenUpdatedDialog(false);
    };
    const handleUpdate = () => {
        navigator.serviceWorker.getRegistrations()
            .then((registrations) => {
                Promise.all(registrations.map((r) => r.unregister()));
            })
            .then(() => {
                localStorage.setItem("APP_VERSION", versionNo);
                localStorage.setItem("APP_ALERT", "");
                localStorage.setItem("ShowUpdateDialog", true)
                setOpenDialog(false);
                window.location.reload();
            })
    }

    // set Local storage PWA or local Storage
    useEffect(() => {
        const isBrowser = window.matchMedia('(display-mode: browser)').matches;

        const installMode = isBrowser ? 'browser' : 'PWA';

        // Set the installMode variable in local storage
        localStorage.setItem('installMode', installMode);
    }, [window.matchMedia('(display-mode: browser)').matches]);

    const updateApp = async () => {
        if (isUpdateInProgressRef.current) return;
        isUpdateInProgressRef.current = true;

        const normalizeVersion = (value) => (value || "").toString().trim();

        try {
            const response = await fetch(`/version.txt?ver=${Date.now()}`, {
                cache: "no-store",
                headers: {
                    "Cache-Control": "no-cache, no-store, must-revalidate",
                    Pragma: "no-cache",
                    Expires: "0",
                },
            });

            const latestVersion = normalizeVersion(await response.text());
            const currentVersion = normalizeVersion(localStorage.getItem("APP_VERSION"));

            if (!latestVersion) return;

            if (!currentVersion) {
                localStorage.setItem("APP_VERSION", latestVersion);
                return;
            }

            if (currentVersion === latestVersion) {
                console.log("[SW] App is up to date");
                return;
            }

            const registrations = await navigator.serviceWorker.getRegistrations();

            if (latestVersion.includes("*")) {
                // Breaking change: unregister all SWs and hard reload
                await Promise.all(registrations.map((r) => r.unregister()));
                localStorage.setItem("APP_VERSION", latestVersion);
                localStorage.setItem("ShowUpdateDialog", "true");
                window.location.reload();
                return;
            }

            // Register a controllerchange listener BEFORE triggering the SW update.
            // controllerchange fires precisely when the new SW has activated and
            // claimed all clients via clientsClaim() — this is the safe moment to reload.
            // Using a fixed timeout is unreliable because the reload could happen before
            // the new SW finishes installing, causing the old SW to serve stale content.
            let reloaded = false;
            let fallbackTimeout;

            const doReload = () => {
                console.log("[SW] Controller changed, reloading page...");
                if (reloaded) return;
                reloaded = true;
                clearTimeout(fallbackTimeout);
                navigator.serviceWorker.removeEventListener('controllerchange', doReload);
                localStorage.setItem("APP_VERSION", latestVersion);
                localStorage.setItem("ShowUpdateDialog", "true");
                window.location.reload();
            };

            navigator.serviceWorker.addEventListener('controllerchange', doReload);
            // Fallback: if controllerchange never fires (e.g. no SW change on server),
            // reload after 15s so the version in localStorage still gets updated.
            fallbackTimeout = setTimeout(doReload, 15000);

            setVersionNo(latestVersion);
            setOpen(true);

            // Trigger the browser to fetch and install the new sw.js from the server.
            // The generated sw.js calls self.skipWaiting() directly, so the new SW will
            // activate immediately after installation without a waiting phase.
            await Promise.all(registrations.map((r) => r.update?.().catch(() => null)));

            // In case a waiting worker already exists (e.g. previous failed update cycle)
            registrations.forEach(r => {
                if (r.waiting) {
                    r.waiting.postMessage({ type: "SKIP_WAITING" });
                }
            });

            console.log("[SW] Update triggered, waiting for new service worker to activate...");
        } catch (error) {
            console.log("[SW] Update check failed", error);
        } finally {
            isUpdateInProgressRef.current = false;
        }
    }
    const handleTheme = (e) => {
        const newMode = e;
        // console.log(e.target.checked)
        setIsDarkMode(newMode);
        localStorage.setItem('darkMode', newMode);
    };
    const handlestateFromChildMenu = (value) => {
        setPathMenu(value)
    }
    const handlestateFromDrawer = (value) => {
        setIsOpenDrawer(value);
    }
    //check for theme mode
    useEffect(() => {
        if (localStorage.getItem("selectedMode") === "dark") {
            setData({ ...data, themeMode: "dark" })
        } else if (localStorage.getItem("selectedMode") === "light") {
            setData({ ...data, themeMode: "light" })
        } else {
            if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                handleTheme(true)
            } else {
                handleTheme(false)
            }
            setData({ ...data, themeMode: "auto" })
        }
    }, [])
    //three click 
    let navigate = useNavigate()
    //Expose a navigate function globally
    useEffect(() => {
        setNavigator(navigate);
    }, [navigate]);


    const [open, setOpen] = React.useState(false);

    const handleClosea = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    const action = (
        <React.Fragment>
            <Button color="secondary" size="small" onClick={handleClosea}>

            </Button>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClosea}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );
    const host = window.location.hostname;
    return (
        <Root>
            <BackdropLoader open={refreshTokenLoader} loadingText={"Refreshing Session..."} />
            <GlobalSnackbar />
            <GlobalToast />

            {/* <Paper elevation={0} id="AppWrapper"> */}
            <Snackbar
                open={open}
                autoHideDuration={5000}
                onClose={handleClosea}
                message={`App Updated Successfully ${versionNo}`}
                action={action}
            />
            <ThemeProvider theme={isDarkMode ? dark : light}>
                <CssBaseline />
                <GlobalStyles />
                {/* <Router> */}

                <AppSignalRManager />
                <RoutesDefinition isDarkMode={isDarkMode} handleTheme={handleTheme} rightDrawer={!isOpenDrawer} handlestateFromChildMenu={handlestateFromChildMenu} />
                {showPopup && (
                    <DialogBox
                        open={showPopup}
                        onClose={handleCloseIOSPWADialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <Box className="titleDialog">
                            <Typography variant='body2'>Add to Home Screen</Typography>
                        </Box>
                        <Divider />
                        <DialogContent sx={{ padding: "20px" }}>
                            <Box sx={{ height: "fit-content" }} >
                                <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                    <img src={heartBlack} alt='mainLogo' className='heartimg' />
                                    <Typography textAlign={'center'} variant='subtitle2' >Install this application on your home screen for a better experience.</Typography>

                                    <Box sx={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                                        <Typography variant='span'>Tab</Typography>
                                        <IosShareIcon sx={{ fontSize: isTab ? "22px" : "18px" }} />
                                        <Typography variant='span'>then "Add to Home Screen"</Typography>
                                    </Box>
                                </Box>
                                <Box sx={{ display: "flex", justifyContent: "center", marginTop: "15px", }} >
                                    <Button fullWidth onClick={() => handleCloseIOSPWADialog()} className='closeBtn' color='success' variant="text">Close</Button>
                                </Box>
                            </Box>
                        </DialogContent>
                    </DialogBox>
                )}
                {/* </Router> */}
            </ThemeProvider>
            {/* Dialog  */}
            <DialogBox
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <Box className="titleDialog">
                    <Typography variant='body2'>Update available</Typography>
                </Box>
                <Divider />
                <DialogContent sx={{ padding: "20px" }}>
                    <Box className="description" >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img className="launch rocket" alt='rocket' width={"60px"} src={rocketIcon} />
                            <Typography variant='subtitle2'>{dialogText}</Typography>
                        </Box>
                        <Box className="buttons" >
                            <Button onClick={() => handleClose()} color='error' variant="contained">Cancel</Button>
                            <Button onClick={() => handleUpdate()} color="success" variant="contained">Update</Button>
                        </Box>
                    </Box>
                </DialogContent>
            </DialogBox>
            {/* Updated Dialog */}
            <DialogBox
                open={openUpdatedDialog}
                onClose={handleCloseUpdatedDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <Box className="titleDialog">
                    <Typography variant='body2'>Updated</Typography>
                </Box>
                <Divider />
                <DialogContent sx={{ padding: "25px" }}>
                    <Box className="UpdatedDescription">
                        <img src={happyfaceIcon} width={120} height={120} alt='smile' />
                        <Typography variant='subtitle2'>{versionText}</Typography>
                        <Button onClick={() => handleCloseUpdatedDialog()} color="success" variant="contained">OK</Button>
                    </Box>
                </DialogContent>
            </DialogBox>
            {/* </Paper> */}
        </Root>
    );
}

export default AppV2;
